import MessageBus from '@gaming/mtt-postal-kit';

if (process.env.REACT_APP_MULTI_THREADED === 'true') {
  MessageBus.instanceId('backend');
  // eslint-disable-next-line global-require
  require('./root');
} else {
  // eslint-disable-next-line global-require
  require('./root');
}
